import React from 'react'
import AddProjectsSection from '../../sections/Projects/AddProjectsSection/AddProjectsSection'

const AddProjectPage = () => {
    return (
        <div className='flex justify-center w-full'>
            <AddProjectsSection />
        </div>
    )
}

export default AddProjectPage
